import { render, staticRenderFns } from "./FinishingPlaster.vue?vue&type=template&id=ba6874e8&"
import script from "./FinishingPlaster.vue?vue&type=script&lang=js&"
export * from "./FinishingPlaster.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports